<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Loved It'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form" novalidate action="#">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-text
            [body]="'We\'re glad you loved it!'" />
        </tidy-row>
        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="'Leave'" /><span>&nbsp;</span>
              <tidy-text
                [header]="feedbackData.homekeeper.firstName" /><span>&nbsp;</span>
                <tidy-text
                  [header]="'a Review'" />
              </tidy-row>
              <tidy-row class="field-top-padding">
                <tidy-textarea
                  [label]="'Review'"
                  [icon]="'assets/svg/chatbubble-ellipses-outline.svg'"
                  formControlName="feedback"
                  [form]="form.controls.feedback"
                  [submitted]="submitted" />
              </tidy-row>
            </tidy-card>
            <tidy-card>
              <tidy-row>
                <tidy-text
                  [header]="'Leave'" /><span>&nbsp;</span>
                  <tidy-text
                    [header]="feedbackData.homekeeper.firstName" /><span>&nbsp;</span>
                    <tidy-text
                      [header]="'a Tip'" />
                  </tidy-row>
                  @if (cleaningData?.plan_frequency === 'once') {
                    <tidy-row class="extra-bottom-padding">
                      <tidy-text
                        [body]="'Tips are common for one time cleanings, but not for recurring plans.'" />
                    </tidy-row>
                  }
                  @if (cleaningData?.plan_frequency !== 'once') {
                    <tidy-row class="extra-bottom-padding">
                      <tidy-text
                        [body]="'Pros make more than average and are aware no tip is required.'" />
                    </tidy-row>
                  }
                  <tidy-row [ngClass]="customTip ? 'field-bottom-padding' : ''">
                    <tidy-radio-button
                      formControlName="tip"
                      [form]="form.controls.tip"
                      [items]="tipOptions"
                      [submitted]="submitted"
                      (optionChange)="customTipping($event)"
                      [errorMessage]="'Please select an option.'" />
                  </tidy-row>
                  @if (customTip) {
                    <tidy-row>
                      <tidy-input
                        [label]="'Enter custom tip'"
                        [icon]="'assets/svg/cash-outline.svg'"
                        formControlName="tip"
                        [form]="form.controls.tip"
                        inputMode="numeric"
                        [mask]="'currencyMask'" />
                    </tidy-row>
                  }
                </tidy-card>
                <tidy-button
                  [text]="'Submit Review'"
                  [action]="boundSubmitFeedback"
                  class="primary" />
              }
            </tidy-wrapper>
          </form>
        </ng-template>

        @if (!isRightSideContent) {
          <app-scroll-wrapper [templateContent]="content" />
        }

        @if (isRightSideContent) {
          <ion-content class="ion-content-right-column">
            <ng-container *ngTemplateOutlet="content" />
          </ion-content>
        }
